import { httpGet, httpPost } from "../Web";
import { ApiResponse } from "./ApiResponse";
import { FieldType } from "./Interface";
import { WorkshopTestResult } from "./WorkshopResult";

export interface WSTestingKeyValue {
    wsProdUpperId: number,      // The workshop product ID this result belongs to, top level of tree should always be set
    testCombinationId: number,  // The test combination ID this result belongs to, if any, second level of tree. If 0, then is top level
    wsTreeEntryType: number,    // The type of this entry in the tree, thrid level of tree. 1=provider, 2=consumer, 0=not for this level
    interfaceId: number,        // The interface ID this result belongs to, if any, forth level of tree. If 0, then not for this level
    companyId: number,          // The company ID this result belongs to, if any, fifth level of tree. If 0, then not for this level
    wsProdLowerId: number       // The workshop product ID this result belongs to, lowest level of tree. If 0, then not for this level
}

export interface WSTestingTreeValue {
    key: WSTestingKeyValue,
    treeNodeName: string,       // The name to show for this node in the tree
    testsPassed: number,        // Test Resuult sumary for this level of tree
    testsFailed: number,        // Test Resuult sumary for this level of tree
    testsWarning: number,       // Test Resuult sumary for this level of tree
    testsNotCompleted: number,  // Test Resuult sumary for this level of tree
}

export interface ProductPairInterfaces {
    interfaceId: number;
    supportedByProduct: boolean;
    name: string;
    shortName: string;
    serverEndpoint: string;
}

export interface ProductPairData {
    productId: number;
    wsProductId: number;
    readyToTest: boolean;
    description: string;
    companyName: string;
    productVersion: string;
    productName: string;
    productPairInterfaceData: ProductPairInterfaces[];
}

export interface WorkshopProductPairTestCaseResult {
    id: number;
    workshopResultId: number;
    testCaseId: number;
    result: WorkshopTestResult;
    fieldTypeVal: FieldType;
    sortOrder: number;
    guid: string;
    value: string;
    comment: string;
    group: string;
    name: string;
    description: string;
    fieldSchema: string;
}

export interface IfacePropertySchema {
    maxRows: number;
    minRows: number;
    isRequired: boolean;
    columns: string[] | null;
}

export interface WorkshopProductPairProperty {
    wppId: number;
    interfaceId: number;
    interfacePropertyId: number;
    fieldTypeVal: FieldType;
    group: string;
    name: string;
    fieldSchema: string;
    value: string;
    rows: string[][] | null;
    jsonErrorSchema: boolean;
    jsonErrorValue: boolean;
    fieldSchemaObject: IfacePropertySchema | null;
}

export interface WSTestingProductPairValue {
    version: number;    // Used to track changes to the data, so UI can decide if it needs to refresh
    workshopResultsId: number;
    interfaceId: number;
    testCombinationId: number;
    workshopId: number;
    interfaceName: string;
    interfaceShortName: string;
    combinationName: string;
    combinationProvider: string;
    combinationConsumer: string;
    clientProduct: ProductPairData;
    serverProduct: ProductPairData;
    testCaseResults: WorkshopProductPairTestCaseResult[];
    testCaseProperties: WorkshopProductPairProperty[];
}

export const GetEmptyTestingKey = () => {
    let keyVal: WSTestingKeyValue = {
        wsProdUpperId: 0,
        testCombinationId: 0,
        wsTreeEntryType: 0,
        interfaceId: 0,
        companyId: 0,
        wsProdLowerId: 0
    }
    return keyVal;
}

export const getWorkshopTestingTree = (workshopId: number, abortController: AbortController): Promise<ApiResponse<WSTestingTreeValue[]>> =>
    httpGet(`/api/workshoptesting/gettestingtree/${workshopId}`, abortController);

export const gettestingpairdata = (productpair: string, abortController: AbortController): Promise<ApiResponse<WSTestingProductPairValue>> =>
    httpGet(`/api/workshoptesting/gettestingpairdata/${productpair}`, abortController);

export const updateWsResultwCounter = (wsResult: WorkshopProductPairTestCaseResult, abortController: AbortController): Promise<ApiResponse<WorkshopProductPairTestCaseResult>> =>
    httpPost(`/api/workshoptesting/testcase/update/`, wsResult, abortController);
